import React, { useEffect, useState } from 'react';
import api from '../../_helpers/api';
import axios from 'axios';
import { Loader } from 'rsuite';
import { Card } from 'Components/Common/Card/Card';

export const CCFEReceptor = (props) => {
  const { receptor, codigoGeneracion } = props;
  const [catDefsRec, setCatDefsRec] = useState({ loading: true });

  const getCATDef_Rec = () => {
    const reqs = [];

    if (receptor.direccion) {
      reqs.push(
        api.post(`${api.getUri()}CAT/CAT012`, { code: receptor.direccion.departamento }),
        api.post(`${api.getUri()}CAT/CAT013`, { code: receptor.direccion.municipio })
      );
    }

    axios.all(reqs).then(
      axios.spread((departamento, municipio) => {
        const state = {
          loading: false,
        };

        if (departamento) state.departamento = departamento.data.items.pop();
        if (municipio) state.municipio = municipio.data.items.pop();

        setCatDefsRec(state);
      })
    );
  };

  useEffect(() => {
    getCATDef_Rec();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigoGeneracion]);

  return (
    <Card header={'¿Quién recibe el DTE?'}>
      <dl>
        <dt>Nombre</dt>
        <dd>{receptor.nombre}</dd>
        <dt>NIT Emisor</dt>
        <dd>{receptor.nit}</dd>
        <dt>NRC</dt>
        <dd>{receptor.nrc}</dd>
        {receptor.nombreComercial && (
          <>
            <dt>Nombre comercial</dt>
            <dd>{receptor.nombreComercial}</dd>
          </>
        )}
        <dt>Dirección</dt>
        <dd>
          {catDefsRec.loading ? (
            <Loader />
          ) : (
            `${receptor.direccion.complemento}. ${catDefsRec.departamento.value}, ${catDefsRec.municipio.value}`
          )}
        </dd>
        <dt>Actividad</dt>
        <dd>{receptor.descActividad}</dd>
        {receptor.telefono && (
          <>
            <dt>Teléfono</dt>
            <dd>{receptor.telefono}</dd>
          </>
        )}
        <dt>Correo</dt>
        <dd>
          <a href={`mailto:${receptor.correo}`}>{receptor.correo}</a>
        </dd>
      </dl>
    </Card>
  );
};
